import { render, staticRenderFns } from "./ModalColegio.vue?vue&type=template&id=6006b660&"
import script from "./ModalColegio.vue?vue&type=script&lang=js&"
export * from "./ModalColegio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports